import * as React from 'react';
import styled from 'styled-components';

const StyledBgPath = styled.path`
  fill: ${props => props.theme.primary};
`;

export const Download = () => (
  <svg width="122" height="119" fill="none" xmlns="http://www.w3.org/2000/svg">
    <StyledBgPath d="M3.092.592A2.476 2.476 0 0 0 .616 3.07v113.428a2.48 2.48 0 0 0 2.476 2.477h116.001a2.48 2.48 0 0 0 1.751-.725 2.48 2.48 0 0 0 .725-1.752V3.069a2.478 2.478 0 0 0-2.476-2.477h-116z" />
    <path
      d="M89.604 94.852H30.18a4.63 4.63 0 0 1-4.68-4.582V75.41a2.181 2.181 0 0 1 3.054-2.222 2.18 2.18 0 0 1 1.28 2.222v14.86a.347.347 0 0 0 .346.248h59.424a.347.347 0 0 0 .346-.248V75.41a2.18 2.18 0 1 1 4.333 0v14.86a4.63 4.63 0 0 1-4.68 4.582z"
      fill="#fff"
    />
    <path
      d="M59.842 74.32a2.153 2.153 0 0 1-2.179-2.154V32.293a2.18 2.18 0 0 1 4.333 0v39.873a2.155 2.155 0 0 1-2.154 2.155z"
      fill="#fff"
    />
    <path
      d="M59.842 78.63a2.08 2.08 0 0 1-1.535-.644L39.737 59.41a2.13 2.13 0 0 1 0-3.07 2.178 2.178 0 0 1 3.07 0l17.035 17.038L76.877 56.34a2.178 2.178 0 0 1 3.07 3.071l-18.57 18.575a2.155 2.155 0 0 1-1.535.644z"
      fill="#fff"
    />
  </svg>
);

export const Create = () => (
  <svg
    width="122"
    height="119"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-418 221 122 119"
  >
    <StyledBgPath d="M-415.1 221.4c-1.4 0-2.5 1.1-2.5 2.5v113.4c0 1.4 1.1 2.5 2.5 2.5h116c1.4 0 2.5-1.1 2.5-2.5V223.8c0-1.4-1.1-2.5-2.5-2.5h-116v.1z" />
    <path
      d="M-324.9 321.7h-65.5c-.3 0-.6-.3-.6-.6v-84.2c0-.3.3-.6.6-.6h49.7c.2-.1.5 0 .7.1l15.6 15.6c.1.1.2.3.2.5V321c-.1.4-.4.7-.7.7zm-64.9-1.3h64.3V253h-15c-.3 0-.6-.3-.6-.6v-14.9h-48.7v82.9zm49.9-68.7h13.4l-13.4-13.4v13.4zm2.5 60.6H-378c-.3 0-.6-.3-.6-.6v-46.8c0-.3.3-.6.6-.6h40.6c.3 0 .6.3.6.6v46.5c0 .6-.3.9-.6.9zm-15-1.3h14.3v-8.1h-14.3v8.1zm-15.6 0h14.3v-8.1H-368v8.1zm-9.3 0h8.1v-8.1h-8.1v8.1zm24.9-9.3h14.3v-8.1h-14.3v8.1zm-15.6 0h14.3v-8.1H-368v8.1zm-9.3 0h8.1v-8.1h-8.1v8.1zm24.9-9.4h14.3v-8.1h-14.3v8.1zm-15.6 0h14.3v-8.1H-368v8.1zm-9.3 0h8.1v-8.1h-8.1v8.1zm24.9-9.4h14.3v-8.1h-14.3v8.1zm-15.6 0h14.3v-8.1H-368v8.1zm-9.3 0h8.1v-8.1h-8.1v8.1zm24.9-9.3h14.3v-8.1h-14.3v8.1zm-15.6 0h14.3v-8.1H-368v8.1zm-9.3 0h8.1v-8.1h-8.1v8.1z"
      fill="#fff"
    />
  </svg>
);

export const Upload = () => (
  <svg width="122" height="119" fill="none" xmlns="http://www.w3.org/2000/svg">
    <StyledBgPath d="M2.76.115A2.476 2.476 0 0 0 .284 2.592v113.453a2.475 2.475 0 0 0 2.476 2.477h116a2.473 2.473 0 0 0 2.476-2.477V2.592A2.478 2.478 0 0 0 118.76.115h-116z" />
    <path
      d="M89.098 94.573H29.674a4.627 4.627 0 0 1-4.315-2.83 4.63 4.63 0 0 1-.365-1.777v-14.86a2.18 2.18 0 1 1 4.333 0v14.86a.322.322 0 0 0 .347.273h59.424a.322.322 0 0 0 .347-.273v-14.86a2.18 2.18 0 1 1 4.333 0v14.86a4.657 4.657 0 0 1-4.68 4.607z"
      fill="#fff"
    />
    <path
      d="M59.312 34.786a2.153 2.153 0 0 0-2.155 2.18v39.848a2.181 2.181 0 0 0 2.167 2.412 2.179 2.179 0 0 0 2.166-2.412V36.966a2.153 2.153 0 0 0-2.178-2.18z"
      fill="#fff"
    />
    <path
      d="M59.312 30.478a2.155 2.155 0 0 0-1.536.644l-18.57 18.574a2.178 2.178 0 1 0 3.07 3.071l17.036-17.039 17.034 17.04a2.205 2.205 0 1 0 3.17-3.072l-18.57-18.574a2.105 2.105 0 0 0-1.535-.644"
      fill="#fff"
    />
  </svg>
);

export const Mail = () => (
  <svg
    width="122"
    height="119"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-418 221 122 119"
  >
    <StyledBgPath d="M-415.2 221.1c-1.4 0-2.5 1.1-2.5 2.5V337c0 1.4 1.1 2.5 2.5 2.5h116c1.4 0 2.5-1.1 2.5-2.5V223.6c0-1.4-1.1-2.5-2.5-2.5h-116z" />
    <path
      d="M-382.5 310c-2.5 0-4.6-2-4.6-4.6v-7.6h1.5v7.6c0 1.7 1.4 3 3 3h60.6c1.7 0 3-1.4 3-3v-39.8c0-1.7-1.4-3-3-3h-60.6c-1.7 0-3 1.4-3 3v10.6h4.9v1.5h-18.9v-1.5h12.5v-10.6c0-2.5 2-4.6 4.6-4.6h60.6c2.5 0 4.5 2.1 4.6 4.6v39.8c0 2.5-2.1 4.5-4.5 4.6h-60.7zm58.3-5.9l-15.2-15.2 1.1-1.1 15.2 15.2-1.1 1.1zm-55.8 0l-1.1-1.1 15.2-15.2 1.1 1.1-15.2 15.2zm1.3-11.2h-18.9v-1.5h18.9v1.5zm26.7-.9c-3.1 0-6.2-1.2-8.6-3.5l-21.8-21.7h60.6l-21.7 21.7c-2.3 2.3-5.4 3.5-8.5 3.5zm-26.7-23.7l19.2 19.1c4.1 4.1 10.9 4.1 15 0l19.1-19.1h-53.3zm-7.5 17H-407v-1.5h20.8v1.5z"
      fill="#fff"
    />
  </svg>
);

export const Error = () => (
  <svg width="122" height="119" fill="none" xmlns="http://www.w3.org/2000/svg">
    <StyledBgPath d="M2.76.115A2.476 2.476 0 0 0 .284 2.592v113.453a2.475 2.475 0 0 0 2.476 2.477h116a2.473 2.473 0 0 0 2.476-2.477V2.592A2.478 2.478 0 0 0 118.76.115h-116z" />
    <path
      d="M93.109 87.687a.643.643 0 0 1-.57.322H29.997a.644.644 0 0 1-.57-.322.718.718 0 0 1 0-.644l31.322-54.262a.62.62 0 0 1 .57-.322.618.618 0 0 1 .569.322l31.321 54.262a.644.644 0 0 1 0 .644h-.1zm3.045-2.476L64.66 31.072a4.061 4.061 0 0 0-5.538-1.49 3.986 3.986 0 0 0-1.47 1.49L26.407 85.36a4.062 4.062 0 0 0 3.49 6.068H92.54a4.01 4.01 0 0 0 3.515-2.03 4.063 4.063 0 0 0 0-4.038"
      fill="#fff"
    />
    <path
      d="M63.397 72.63l1.51-24.816H57.53l1.51 24.816h4.358zM61.218 74.587a3.763 3.763 0 1 0-.05 7.526 3.763 3.763 0 0 0 .05-7.526z"
      fill="#fff"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulkExcel/components/Icons.tsx